<template>
  <v-container>
    <v-row justify="center">
      <v-col class="text-center">
        <span class="font-subtitle-1">
          ลงชื่อเข้าใช้งานหรือสมัครสมาชิกยังแฮปปี้<br />ด้วยเบอร์โทรศัพท์ที่ใช้อยู่ขณะนี้
        </span>
      </v-col>
    </v-row>
    <div v-if="!lineLoginReady">
      <v-row justify="center" align="center">
        <v-col cols="5">
          <v-select
            :items="codes"
            item-text="country.native_name"
            item-value="Code"
            label="ประเทศ"
            placeholder="เลือกประเทศ"
            :disabled="otpRef == '' ? false : true"
            v-model="code"
            outlined
          ></v-select>
        </v-col>
        <v-col>
          <v-text-field
            v-model="phoneNumberWithMask"
            v-mask="maskPhoneNumber"
            label="เบอร์โทรศัพท์"
            placeholder="ระบุเบอร์โทรศัพท์ 10 หลัก"
            :disabled="otpRef == '' ? false : true"
            outlined
            @keyup="phoneNumberRemoveMask()"
          />
        </v-col>
      </v-row>
      <div v-if="otpRef">
        <v-row justify="center">
          <v-col class="text-center">
            <span>
              ระบุรหัส OTP ที่ได้รับทาง SMS เพื่อเข้าสู่ระบบ<br />รหัส OTP
              ของคุณมีอายุการใช้งาน 5 นาที
            </span>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="6" md="4">
            <v-text-field
              v-model="otp"
              v-mask="maskOTP"
              label="OTP"
              placeholder="รหัสยืนยัน 4 หลัก"
              :disabled="btnVerifyOTPLoading"
              outlined
              @keyup.enter="verifyOTP"
            />
          </v-col>
        </v-row>
        <v-row justify="center">
          <div class="d-flex flex-row justify-center align-center">
            <span>ไม่ได้รับ OTP</span>
            <v-btn
              class="font-subhead-1 px-2"
              color="primary"
              :ripple="false"
              :disabled="reSendOtpCountDown > 0"
              text
              @click="OTPCountDown"
            >
              <span>ส่งอีกครั้ง</span>
              <span v-if="reSendOtpCountDown > 0"
                >({{ reSendOtpCountDown }} วินาที)</span
              >
            </v-btn>
          </div>
        </v-row>
      </div>
      <v-row justify="center">
        <v-col cols="8" md="6">
          <v-btn
            v-if="!otpRef"
            class="white--text"
            color="primary"
            large
            block
            :disabled="$v.phoneNumber.$invalid"
            @click="sendOPT"
          >
            รับรหัส OTP
          </v-btn>
          <v-btn
            v-else
            class="white--text"
            color="primary"
            large
            block
            :disabled="$v.otp.$invalid"
            :loading="btnVerifyOTPLoading"
            @click="verifyOTP"
          >
            ตกลง
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div v-if="lineLoginReady">
      <v-row justify="center" align="center">
        <v-col cols="5">
          <v-select
            :items="codes"
            item-text="country.native_name"
            item-value="Code"
            label="ประเทศ"
            placeholder="เลือกประเทศ"
            :disabled="otpRef == '' ? false : true"
            v-model="code"
            outlined
          ></v-select>
        </v-col>
        <v-col>
          <v-text-field
            v-model="phoneNumberWithMask"
            v-mask="maskPhoneNumber"
            label="เบอร์โทรศัพท์"
            placeholder="ระบุเบอร์โทรศัพท์ 10 หลัก"
            :disabled="otpRef == '' ? false : true"
            outlined
            @keyup="phoneNumberRemoveMask()"
          />
        </v-col>
      </v-row>
      <div v-if="otpRef">
        <v-row justify="center">
          <v-col class="text-center">
            <span>
              ระบุรหัส OTP ที่ได้รับทาง SMS เพื่อเข้าสู่ระบบ<br />รหัส OTP
              ของคุณมีอายุการใช้งาน 5 นาที
            </span>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="6" md="4">
            <v-text-field
              v-model="otp"
              v-mask="maskOTP"
              label="OTP"
              placeholder="รหัสยืนยัน 4 หลัก"
              :disabled="btnVerifyOTPLoading"
              outlined
              @keyup.enter="verifyOTP"
            />
          </v-col>
        </v-row>
        <v-row justify="center">
          <div class="d-flex flex-row justify-center align-center">
            <span>ไม่ได้รับ OTP</span>
            <v-btn
              class="font-subhead-1 px-2"
              color="primary"
              :ripple="false"
              :disabled="reSendOtpCountDown > 0"
              text
              @click="OTPCountDown"
            >
              <span>ส่งอีกครั้ง</span>
              <span v-if="reSendOtpCountDown > 0"
                >({{ reSendOtpCountDown }} วินาที)</span
              >
            </v-btn>
          </div>
        </v-row>
      </div>
    </div>

    <v-row v-if="lineLoginReady" justify="center">
      <v-col cols="8" md="6">
        <v-btn
          v-if="!otpRef"
          class="white--text"
          color="primary"
          large
          block
          :disabled="$v.phoneNumber.$invalid"
          @click="sendLineOTP"
        >
          LOGIN </v-btn
        ><v-btn
          v-else
          class="white--text"
          color="primary"
          large
          block
          :disabled="$v.otp.$invalid"
          :loading="btnVerifyOTPLoading"
          @click="verifyLineOTP"
        >
          ตกลง
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="!lineLoginReady" justify="center">
      <v-col cols="8" md="6">
        <v-btn class="white--text" color="line" large block @click="liffLogin">
          <div class="line-btn">
            <img src="/line.png" alt="" />
            เข้าสู่ระบบด้วย Line
          </div>
        </v-btn>
      </v-col>
    </v-row>
    <v-overlay :value="!liffIsReady || lineOverlay">
      <v-progress-circular
        indeterminate
        color="#B6E28A"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
import {
  required,
  numeric,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { encrypt } from "~/assets/js/encryption";
import axios from "~/plugins/axios";

export default {
  directives: {
    mask
  },
  middleware: "notAuthenticated",
  asyncData({ $axios, route }) {
    const inviterID = route.query.inviter_id || 0;
    const inviterCommunityID = route.query.inviter_community_id || 1;
    return $axios.get("/code/get").then(res => {
      return {
        codes: res.data.data.codes,
        inviterID: inviterID,
        inviterCommunityID: inviterCommunityID
      };
    });
  },
  head() {
    return {
      title: "ลงชื่อเข้าใช้งานหรือสมัครสมาชิกยังแฮปปี้"
    };
  },
  data() {
    return {
      phoneNumber: "",
      phoneNumberWithMask: "",
      maskPhoneNumber: "###-###-####",
      otp: "",
      maskOTP: "####",
      code: "66",
      otpRef: "",
      btnVerifyOTPLoading: false,
      reSendOtpCountDown: 0,
      lineLoginReady: false,
      lineUid: "",
      liffIsReady: false,
      lineOverlay: false,
      isRegister: false
    };
  },
  methods: {
    phoneNumberRemoveMask() {
      this.phoneNumber = this.phoneNumberWithMask.split("-").join("");
    },
    sendOPT() {
      this.btnVerifyOTPLoading = true;
      this.otp = "";
      this.$axios
        .post("/send-otp", {
          phone_number: this.phoneNumber,
          country_code: this.code
        })
        .then(res => {
          this.otpRef = res.data.data.otp_ref;
        })
        .catch(() => {
          alert("Can't send OTP for unknow issue. Plese try again later.");
        })
        .finally(() => {
          this.btnVerifyOTPLoading = false;
        });
    },
    async sendLineOTP() {
      this.lineOverlay = true;
      await this.$axios
        .post("/line-login", {
          code: this.code,
          phone_number: this.phoneNumber,
          line_uid: this.lineUid
        })
        .then(async res => {
          const { is_register } = res?.data?.data;
          if (is_register) {
            await this.$axios
              .post("/validate", {
                phone_number: this.phoneNumber,
                country_code: this.code
              })
              .then(res => {
                res.data.data.is_register = true;
                this.loginHandler(res);
              });
          } else {
            this.$axios
              .post("/send-otp", {
                country_code: this.code,
                phone_number: this.phoneNumber
              })
              .then(res => {
                this.otpRef = res.data.data.otp_ref;
              })
              .catch(() => {
                alert(
                  "Can't send OTP for unknow issue. Plese try again later."
                );
              })
              .finally(() => {
                this.lineOverlay = false;
              });
          }
        })
        .catch(err => {
          alert("Can't send OTP for unknow issue. Plese try again later.");
        })
        .finally(() => {
          this.lineOverlay = false;
        });
    },
    async verifyOTP() {
      this.btnVerifyOTPLoading = true;
      this.$axios
        .post("/verify-otp", {
          otp: this.otp,
          otp_ref: this.otpRef
        })
        .then(res => {
          if (res.status === 200) {
            this.$axios
              .post("/validate", {
                phone_number: this.phoneNumber,
                country_code: this.code
              })
              .then(async res => this.loginHandler(res));
          }
        })
        .catch(err => {
          if (err.response.status === 406) {
            alert("Incorrect OTP. Please try again.");
            this.otp = "";
            this.btnVerifyOTPLoading = false;
          }
        });
    },
    async verifyLineOTP() {
      this.lineOverlay = true;
      this.$axios
        .post("/verify-otp-line", {
          otp: this.otp,
          otp_ref: this.otpRef,
          line_uid: this.lineUid
        })
        .then(async res => {
          const { success } = res.data;
          if (success) {
            await this.$axios
              .post("/line-login", {
                code: this.code,
                phone_number: this.phoneNumber,
                line_uid: this.lineUid
              })
              .then(res => {
                this.loginHandler(res);
              });
          }
        })
        .catch(err => {
          if (err.response.status === 406) {
            alert("Incorrect OTP. Please try again.");
            this.otp = "";
          }
        });
    },
    async loginHandler(res) {
      this.lineOverlay = true;
      if (res.status === 200) {
        await this.$fire.auth.signInWithCustomToken(res.data.data.custom_token);
        this.$store.dispatch("authenticated/login");
        this.$cookies.set(
          "auth",
          encrypt(this.$fire.auth.currentUser.phoneNumber),
          {
            maxAge: 60 * 60 * 24 * 30,
            path: "/"
          }
        );
        if (res.data.data.is_register === true) {
          if (this.inviterID === 0)
            this.$router.push(
              `/account/register?redirect=${this.$route.query.redirect}`
            );
          else
            this.$router.push(
              `/account/register?inviter_id=${this.inviterID}&inviter_community_id=${this.inviterCommunityID}&redirect=${this.$route.query.redirect}`
            );
        } else {
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          } else if (
            this.$store.state.app.previousPath &&
            this.$store.state.app.previousPath != this.$route.fullPath
          ) {
            this.$router.push(this.$store.state.app.previousPath);
            this.$store.dispatch("app/clearPreviousPath");
          } else {
            window.location.reload();
          }
        }
      }
    },
    registerHandler() {
      if (this.inviterID === 0)
        this.$router.push(
          `/account/register?redirect=${this.$route.query.redirect}`
        );
      else
        this.$router.push(
          `/account/register?inviter_id=${this.inviterID}&inviter_community_id=${this.inviterCommunityID}&redirect=${this.$route.query.redirect}`
        );
    },
    async OTPCountDown() {
      this.sendOPT();
      this.reSendOtpCountDown = 60;
      var timer = setInterval(() => {
        this.reSendOtpCountDown--;
        if (this.reSendOtpCountDown === 0) clearInterval(timer);
      }, 1000);
    },
    async liffLogin() {
      if (!liff.isLoggedIn()) {
        liff.login();
      }
    }
  },
  validations: {
    phoneNumber: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
      regex(phoneNumber) {
        return /^0.*\d/.test(phoneNumber);
      }
    },
    otp: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4)
    }
  },
  mounted() {
    this.$liffInit.then(() => {
      this.liffIsReady = true;
      if (liff.isLoggedIn()) {
        this.lineUid = "";
        liff.getProfile().then(res => {
          this.lineUid = res.userId;
        });
      }
    });
  },
  watch: {
    lineUid: {
      async handler(userId) {
        this.lineLoginReady = true;
        const { data: resp, success } = await this.$axios
          .get("/line/get/user", { params: { line_uid: userId } })
          .then(res => res.data);

        if (success) {
          await this.$axios
            .post("/line-login", {
              code: this.code,
              phone_number: resp.phone_number,
              line_uid: this.lineUid
            })
            .then(res => this.loginHandler(res));
        } else {
          alert(
            "กรุณาลงชื่อเข้าใช้งาน หรือ สมัครสมาชิกยังแฮปปี้ด้วยเบอร์โทรศัพท์"
          );
          this.isRegister = true;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.line-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 22px;
}
</style>
